// Version du Panneau Debug - Ne pas modifier sans validation PO
export const DEBUG_PANEL_VERSION = {
  version: 'V3 Final',
  buildTime: new Date().toISOString(),
  commitHash: process.env.REACT_APP_COMMIT_HASH || 'local-build',
  deployTime: new Date().toISOString()
};

// Fonction helper pour formater les infos de version
export const getVersionInfo = () => {
  return {
    version: DEBUG_PANEL_VERSION.version,
    build: DEBUG_PANEL_VERSION.buildTime.split('T')[0].replace(/-/g, ''),
    commit: DEBUG_PANEL_VERSION.commitHash.substring(0, 7),
    deployTime: new Date().toISOString().replace('T', ' ').substring(0, 19)
  };
};
